import IztLoading from './src/izt-loading.vue'

IztLoading.install = Vue => {
  Vue.component(IztLoading.name, IztLoading)
}

export default IztLoading